import gql from 'graphql-tag';
import gqlClient from 'js/graphql/client/gqlClient';
import logoutUser from 'js/graphql/logout';

export const queryGeneralGuidelines = async () => {
    try {
        if (gqlClient.client === undefined) {
            await gqlClient.createClient();
        }
        if (gqlClient.client === undefined) {
            throw new Error('Unable to create client');
        }

        const result = await gqlClient.client.query({
            query: gql`
                query GeneralGuidelines {
                    generalGuidelines {
                        edges {
                            node {
                                id
                                must
                                description
                                subject
                                position
                            }
                        }
                    }
                }
            `
        });

        return result.data.generalGuidelines;
    } catch (error) {
        if (error.message.includes('401')) {
            return logoutUser();
        }

        throw error;
    }
};



// WEBPACK FOOTER //
// ./graphql/queries/queryGeneralGuidelines.js